import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

function Footer() {
    return (
        <footer id='footer' style={{}}>
            <div id="logoAndSocialMedia">
                <h1>Signature Move Investment Group </h1>
                <p>© 2022 Developed by<span> TTP TECH LLC</span></p>
                <FontAwesomeIcon style={{ width: '40px', marginLeft: "80px" }} icon={faFacebookF} color="#cfa167" />
                <FontAwesomeIcon type="link" target="_blank" isExternal style={{ width: '40px' }} icon={faInstagram} color="#cfa167"><Link to="https://instagram.com/signaturemove_ig?igshid=YmMyMTA2M2Y="></Link></FontAwesomeIcon>
            </div>
            <div id="links">
                <div id="menu">
                    <h1>Sections</h1>
                    <ul style={{padding: '0'}}>
                        <li><Link to="/" >Home</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/About">About us</Link></li>
                        {/* <li><Link to="/credits">Credits</Link></li> */}
                    </ul>
                </div>
                <div id="services">
                    <h1>Request</h1>
                    <ul style={{padding: '0'}}>
                        <li><Link to="/request">Request</Link></li>
                        <li><Link to="/Appointment">Appointment</Link></li>
                    </ul>
                </div>
                <div id="contact">
                    <span>
                        <FontAwesomeIcon icon={faEnvelope} color="#cfa167" />
                        <p style={{ display: "inline", marginLeft: "4px", color: '#d1d1d1'}}> signaturemoveig@gmail.com</p>
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faPhone} color="#cfa167" />
                        <p style={{ display: "inline", marginLeft: "4px", color: '#d1d1d1'}}> +1 410 204 4070</p>
                    </span>
                </div>
            </div>
        </footer>
    )
}
export default Footer;
